export default __webpack_public_path__ + "static/media/jpg.5e99ad9f.svg";